
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Factor, FactorGroup, FactorResource } from "@/api/model/FactorResource";
import Choices, { Choice } from '@/store/modules/Choices';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Viewpoints from "@/store/modules/Viewpoints";
import { getModule } from "vuex-module-decorators";
import Modelling from "@/store/modules/Modelling";
import Decisions from "@/store/modules/Decisions";
import CreateChoiceDialog from '@/views/ChoiceCards/CreateChoiceDialog.vue';

const workspaceOptionsModule = getModule(WorkspaceOptions)
const viewpointsModule = getModule(Viewpoints);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);

@Component({
    components: { CreateChoiceDialog }
})
export default class ChoiceCardFactorNavigationPanel extends Vue {

    @Prop()
    name!: string;

    @Prop()
    choiceData!: Choice;

    @Prop()
    factorResources!: { [id: string]: FactorResource };

    @Prop({ type: Boolean, default: false })
    disabled!: boolean;

    @Prop()
    currentSelectedId!: string | null;

    @Prop({type: Array, default: () => ([])})
    questionFactors!: any[];

    @Prop()
    startFactor: string

    @Prop({ default: false, type: Boolean })
    appEmbed: boolean;


    private open: any[] = [];
    private activeItems: string[] = this.currentSelectedId ? [this.currentSelectedId] : [];
    private renameChoiceDialog = false;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get steps() {
        return this.questionFactors.length;
    }

    get items() {
        return this.constructSubTree(this.factorResources, this.startFactor);
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get showChartTop() {
        return workspaceOptionsModule.chartTop;
    }

    private async renameChoice(choiceName: string) {
        // NotificationEventBus.emitProcessingMessage();
        if (choiceName != '') {
            choicesModule.renameChoice({ newName: choiceName, choice: this.selectedChoice });
            // NotificationEventBus.emitSuccessMessage();
            
        }
        this.renameChoiceDialog = false;
    }

    private editChoiceName() {
        this.renameChoiceDialog = true;
    }

    private isFactorVisible(resourceId: string) {
         if(this.showNonListFactors || !this.isFactorListActive) {
        //    return  this.contributingVisibility || (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            return true;
        }
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        }
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds && this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    get isViewpointActive() {
        return (viewpointsModule.activeViewpointId != null)
    }

    @Watch('currentSelectedId')
    private onCurrentSelectedId() {
        if (!this.currentSelectedId) {
            this.activeItems = [];
            return;
        }
        this.activeItems = [];
        this.activeItems.splice(0, 0, this.currentSelectedId)
        let path = this.findPath(this.currentSelectedId, 'M', this.factorResources);
        if (path) {
            this.open = path;
        }
        //@ts-ignore
        setTimeout(() => this.$vuetify.goTo('#tree-' + this.currentSelectedId, {
            container: '#tree-view-container',
            offset: 300,
            duration: 100
        }), 500)
    }

    private findPath(searchId: string, currentId: string, factorResources: { [id: string]: FactorResource }): string[] | undefined {
        let factorResource = factorResources[currentId];
        if (factorResource.type === 'FACTOR_GROUP') {
            if ((factorResource as FactorGroup).childrenIds.includes(searchId)) {
                return [currentId]
            }
            for (let childId of (factorResource as FactorGroup).childrenIds) {
                let subsearch = this.findPath(searchId, childId, factorResources);
                if (subsearch) {
                    return [currentId, ...subsearch]
                }
            }
        }
    }


    private constructSubTree(resources: { [id: string]: FactorResource }, factorGroupId: string): any {
        if (resources[factorGroupId]) {
            return (resources[this.getTopGroup(factorGroupId)] as FactorGroup).childrenIds
                .map(fId => resources[fId])
                .filter(f => this.isFactorVisible(f.id))
                .map(f => {
                    if (f.type === 'FACTOR_GROUP') {
                        return {
                            id: f.id,
                            name: f.name,
                            type: 'FACTOR_GROUP',
                            isTable: (f as FactorGroup).groupTypeDefinition && (f as FactorGroup).groupTypeDefinition.type.startsWith('TABLE'),
                            groupTypeDefinition: (f as FactorGroup).groupTypeDefinition,
                            children: !(f as FactorGroup).groupTypeDefinition || !(f as FactorGroup).groupTypeDefinition.type.startsWith('TABLE') ? this.constructSubTree(resources, f.id) : []
                        }
                    }
                    return {
                        id: f.id,
                        name: f.name,
                        type: 'FACTOR',
                        dataField: f.dataField,
                        valueTypeDefinition: (f as Factor).valueTypeDefinition
                    }
                })
        }
        return [];
    }

    private isSubsectionComplete(group: any) {
        if (group.isTable) {
            let table = this.factorResources[group.id] as FactorGroup
            if (table.groupTypeDefinition.type === 'TABLE_GROWING') {
                return !table.childrenIds.map(id => this.factorResources[id])
                    .find(f => this.choiceData[f.dataField || ''] == null)
            } else {
                return !table.childrenIds.map(id => this.factorResources[id] as FactorGroup)
                    .filter(fg => fg.groupTypeDefinition.type === 'TABLE_ROW')
                    .map(fg => fg.childrenIds)
                    .flat()
                    .map(id => this.factorResources[id] as Factor)
                    .find(f => this.choiceData[f.dataField || ''] == null)
            }
        }
        if (!group.children || group.children.length === 0) return true;
        const falseFound = group.children
            .map((child: any) => {
                if (child.type === 'FACTOR_GROUP') {
                    return this.isSubsectionComplete(child);
                }
                if (this.choiceData[child.dataField] == null) return false;
                return true;
            })
            .find((b: boolean) => !b)
        if (falseFound === false) return false;
        return true;
    }

    private clickStep() {
        console.log(this.steps + 1);
        this.$emit('step', this.steps + 1);
    }

}
